import { createSignal, onCleanup, onMount } from "solid-js";

/**
 * The id of the section currently under the in-page nav: the first of `ids`
 * crossing a band just below the sticky chrome, holding the last match while
 * none does. Undefined until the reader reaches the first one.
 */
export const useActiveSection = (ids: string[]) => {
  const [active, setActive] = createSignal<string>();

  onMount(() => {
    const visible = new Set<string>();
    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) visible.add(entry.target.id);
          else visible.delete(entry.target.id);
        }
        const first = ids.find((id) => visible.has(id));
        if (first) setActive(first);
      },
      { rootMargin: "-140px 0px -60% 0px" }
    );
    for (const id of ids) {
      const section = document.getElementById(id);
      if (section) observer.observe(section);
    }
    onCleanup(() => observer.disconnect());
  });

  return active;
};
